/* AURA SUPPLY smart cart recs — rides Horizon's theme-drawer + SRA morph engine.
   Rules honored (cart-aov-boost-design):
   - adds: POST /cart/add.js {id, quantity:1} only; no /cart/update.js, no /cart/clear.js
   - money: Intl.NumberFormat + cart.currency; zero hardcoded symbols
   - items-container-only refresh via /?sections=cart-drawer-section
   - strip rebuilds only on state-signature change
   - +Add only for true single-variant products; everything else gets Choose (inline panel)
   - never auto-opens the drawer; user close always wins (modal dialog owned by theme)
*/
(function () {
  if (window.__auraSmartCart) return;
  window.__auraSmartCart = true;

  var SECTION_ID = 'cart-drawer-section';
  var productCache = {};
  var lastSig = null;
  var cartState = null;

  function cfg() {
    var el = document.getElementById('aura-recs-config');
    try { return el ? JSON.parse(el.textContent) : { pool: [] }; } catch (e) { return { pool: [] }; }
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  function drawerDialog() {
    var td = document.getElementById('cart-drawer');
    return td ? td.querySelector('dialog') : null;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(handle); return r.json(); })
      .then(function (p) { productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  /* ---- refresh theme cart HTML after our own add (items subtree only) ---- */
  function refreshDrawer() {
    return fetch('/?sections=' + SECTION_ID)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections[SECTION_ID];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var host = document.querySelector('#shopify-section-' + SECTION_ID) || document.getElementById('shopify-section-cart-drawer-section');
        if (!host) return;
        var freshInner = tpl.querySelector('.cart-drawer__inner');
        var liveInner = host.querySelector('.cart-drawer__inner');
        if (!freshInner || !liveInner) return;
        var liveItems = liveInner.querySelector('.cart-drawer__items');
        var freshItems = freshInner.querySelector('.cart-drawer__items');
        if (liveItems && freshItems) {
          var st = liveItems.scrollTop;
          liveItems.innerHTML = freshItems.innerHTML;
          liveItems.scrollTop = st;
        } else {
          // empty<->filled transition: swap the whole inner (drawer stays open; header/close unaffected outside inner? inner includes header — acceptable for state flip)
          liveInner.innerHTML = freshInner.innerHTML;
        }
        var freshSummary = freshInner.querySelector('.cart-drawer__summary');
        var liveSummary = liveInner.querySelector('.cart-drawer__summary');
        if (freshSummary && liveSummary) liveSummary.innerHTML = freshSummary.innerHTML;
      });
  }

  function updateBadges(cart) {
    document.querySelectorAll('#cart-drawer .theme-drawer__badge').forEach(function (b) {
      b.textContent = cart.item_count;
      b.classList.toggle('visually-hidden', cart.item_count === 0);
    });
    // AURA custom header bag counter
    document.querySelectorAll('#vvBag .cart-count, header .cart-count, [data-cart-count]').forEach(function (b) {
      b.textContent = cart.item_count;
    });
  }

  function addToCart(variantId, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return Promise.all([refreshDrawer(), fetchCart()]); })
      .then(function (res) {
        cartState = res[1];
        updateBadges(cartState);
        applyCompact(cartState);
        rebuildStrip(cartState);
        document.dispatchEvent(new CustomEvent('aura:cart-updated', { detail: cartState }));
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = '+ Add'; } });
  }

  /* ---- compact mode ---- */
  function applyCompact(cart) {
    var d = drawerDialog();
    if (!d) return;
    var lines = cart ? cart.items.length : 0;
    d.classList.toggle('aura-compact', lines >= 3);
  }

  /* ---- +Add vs Choose ---- */
  function isDirectAddable(p) {
    if (!p || p.variants.length !== 1) return false;
    var avail = p.variants.filter(function (v) { return v.available; });
    if (avail.length !== 1) return false;
    var meaningful = (p.options || []).some(function (o) {
      var name = (o.name || o).toString();
      var values = o.values || [];
      return name !== 'Title' && values.length > 1;
    });
    return !meaningful;
  }

  /* ---- signature-gated strip rebuild ---- */
  function signature(cart) {
    return cart.item_count + '|' + cart.items.map(function (i) { return i.handle; }).sort().join(',');
  }

  function pickRecs(cart, config) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.handle] = true; });
    var picks = [];
    // cart-aware first: upgrade cards when the anchor product is in the cart
    (config.anchors || []).forEach(function (a) {
      if (inCart[a.if_handle]) {
        (a.recommend || []).forEach(function (h) { if (!inCart[h] && picks.indexOf(h) < 0) picks.push(h); });
      }
    });
    (config.pool || []).forEach(function (h) { if (!inCart[h] && picks.indexOf(h) < 0) picks.push(h); });
    return picks.slice(0, 8);
  }

  function rebuildStrip(cart) {
    var strip = document.getElementById('aura-recs');
    if (!strip) return;
    if (!cart || cart.item_count === 0) { strip.hidden = true; lastSig = null; return; }
    var sig = signature(cart);
    var grid0 = strip.querySelector('.aura-recs__grid');
    var gridEmpty = !grid0 || grid0.childElementCount === 0;
    if (sig === lastSig && !gridEmpty) return; // signature-gated, but always rebuild after a theme morph wiped the grid
    lastSig = sig;
    var config = cfg();
    var handles = pickRecs(cart, config);
    if (!handles.length) { strip.hidden = true; return; }

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      products = products.filter(function (p) { return p && p.available !== false; });
      if (!products.length) { strip.hidden = true; return; }
      var grid = strip.querySelector('.aura-recs__grid');
      grid.innerHTML = '';
      products.forEach(function (p) {
        var direct = isDirectAddable(p);
        var card = document.createElement('div');
        card.className = 'aura-rec-card';
        var img = p.featured_image ? (p.featured_image + (p.featured_image.indexOf('?') < 0 ? '?width=180' : '&width=180')) : '';
        var priceHtml = money(p.price, cartState.currency);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          priceHtml = '<span class="was">' + money(p.compare_at_price, cartState.currency) + '</span>' + priceHtml;
        }
        card.innerHTML =
          (img ? '<img src="' + img + '" width="60" height="60" loading="lazy" alt="">' : '') +
          '<div class="aura-rec-info"><div class="aura-rec-title"></div>' +
          '<div class="aura-rec-price">' + priceHtml + '</div></div>' +
          '<button type="button" class="aura-add-btn" data-handle="' + p.handle + '"' +
          (direct ? ' data-variant="' + p.variants[0].id + '"' : '') + '>' +
          (direct ? '+ Add' : 'Choose') + '</button>';
        card.querySelector('.aura-rec-title').textContent = p.title;
        grid.appendChild(card);
      });
      strip.hidden = false;
    });
  }

  /* ---- inline variant panel ---- */
  function closePanel() {
    var p = document.getElementById('aura-vpanel');
    if (p) p.remove();
  }

  function openPanel(product) {
    closePanel();
    var strip = document.getElementById('aura-recs');
    if (!strip) return;
    var panel = document.createElement('div');
    panel.id = 'aura-vpanel';
    panel.className = 'aura-vpanel';
    var opts = product.options.filter(function (o) { return o.name !== 'Title' && o.values.length >= 1; });
    var selected = {};
    opts.forEach(function (o) { selected[o.name] = null; });
    // preselect single-value options
    opts.forEach(function (o) { if (o.values.length === 1) selected[o.name] = o.values[0]; });

    function currentVariant() {
      return product.variants.find(function (v) {
        return opts.every(function (o, idx) {
          var pos = product.options.indexOf(o);
          return v.options[pos] === selected[o.name];
        });
      }) || null;
    }

    function render() {
      var head = '<div class="avp-head"><div class="avp-title"></div>' +
        '<button type="button" class="avp-close" aria-label="Close">×</button></div>';
      var body = '';
      opts.forEach(function (o) {
        body += '<div class="avp-optname">Select ' + o.name.toLowerCase() + '</div><div class="avp-pills" data-opt="' + o.name + '">';
        o.values.forEach(function (val) {
          // disable values with no available variant given other selections
          var test = Object.assign({}, selected); test[o.name] = val;
          var ok = product.variants.some(function (v) {
            return v.available && opts.every(function (oo) {
              var pos = product.options.indexOf(oo);
              return test[oo.name] === null || v.options[pos] === test[oo.name];
            });
          });
          body += '<button type="button" class="avp-pill' + (selected[o.name] === val ? ' sel' : '') + '"' +
            (ok ? '' : ' disabled') + ' data-opt="' + o.name + '" data-val="' + val.replace(/"/g, '&quot;') + '">' + val + '</button>';
        });
        body += '</div>';
      });
      var v = currentVariant();
      var priceHtml = v ? money(v.price, cartState.currency) : money(product.price, cartState.currency);
      var foot = '<div class="avp-foot"><div class="avp-price">' + priceHtml + '</div>' +
        '<button type="button" class="avp-add"' + (v && v.available ? '' : ' disabled') + '>Add to Cart</button></div>';
      panel.innerHTML = head + body + foot;
      panel.querySelector('.avp-title').textContent = product.title;
    }

    render();
    strip.appendChild(panel);
    panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });

    panel.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      var t = e.target;
      if (t.classList.contains('avp-close')) { closePanel(); return; }
      if (t.classList.contains('avp-pill') && !t.disabled) {
        selected[t.getAttribute('data-opt')] = t.getAttribute('data-val');
        render();
        return;
      }
      if (t.classList.contains('avp-add') && !t.disabled) {
        var v = currentVariant();
        if (v) addToCart(v.id, t).then(closePanel);
      }
    }, true);
  }

  /* ---- delegated handlers (capture, on stable document) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.aura-add-btn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var vid = btn.getAttribute('data-variant');
    if (vid) { addToCart(parseInt(vid, 10), btn); return; }
    fetchProduct(btn.getAttribute('data-handle')).then(function (p) { if (p) openPanel(p); });
  }, true);

  /* ---- react to the THEME's own cart updates (qty/remove/add via theme UI) ---- */
  function onThemeCartChange() {
    fetchCart().then(function (cart) {
      cartState = cart;
      applyCompact(cart);
      rebuildStrip(cart);
    });
  }
  document.addEventListener('cart:update', onThemeCartChange);
  // Horizon dispatches StandardEvents.cartLinesUpdate — cover common event names defensively
  ['cartLinesUpdate', 'cart-lines-update', 'shopify:cart:update'].forEach(function (n) {
    document.addEventListener(n, onThemeCartChange);
  });
  // Fetch interceptor as the reliable fallback: any cart mutation endpoint triggers a resync
  var _fetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || String(arguments[0] || '');
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function () { setTimeout(onThemeCartChange, 60); }).catch(function () {});
    }
    return p;
  };

  /* ---- init on drawer open only (never opens the drawer itself) ---- */
  function onOpen() { onThemeCartChange(); }
  var td = document.getElementById('cart-drawer');
  if (td) {
    new MutationObserver(function () {
      if (td.hasAttribute('open')) onOpen();
      else closePanel();
    }).observe(td, { attributes: true, attributeFilter: ['open'] });
    if (td.hasAttribute('open')) onOpen();
  }
  // initial state (for compact class correctness on first open)
  fetchCart().then(function (c) { cartState = c; applyCompact(c); });
})();
